export var schema = {
  title: "Motor",
  description: "Motor Claim Form",
  type: "object",
  properties: {
    incident: {
      type: "object",
      title: "Incident",
      required: ["insureddateloss", "incidentAddress", "incidentDescription"],
      properties: {
        insureddateloss: {
          title: "Date and Time When Incident Occurred?",
          type: "string",
          format: "date-time"
        },
        incidentAddress: {
          type: "string",
          title: "Address Where Incident Occurred?"
        },
        incidentLat: {
          type: "string",
          title: "Latitude"
        },
        incidentLong: {
          type: "string",
          title: "Longitude"
        },
        incidentDescription: {
          type: "string",
          title: "Description of What Occurred?"
        },  
        incidentDriverDrugTest: {
          title: "Was the Driver Tested for Alcohol or Drug Use?",
          type: "string",
          enum: ["Yes", "No"]
        },
        incidentCoverInfo: {
          type: "object",
          title: "",
          required: ["incidentCover"],    
          properties: {
            incidentCover: {
              title: "Is the Incident Covered Under Any Other Policy of Insurance?",
              type: "string",
              enum: ["Yes", "No"]
            }
          },
          dependencies: {
            incidentCover: {
              oneOf: [{
                required: ["incidentPolicyDetails"],  
                properties: {
                  incidentCover: {
                    enum: ["Yes"]
                  },
                  incidentPolicyDetails: {
                    type: "string",
                    title: "Details of Other Policy"
                  }
                }
              }, {
                properties: {
                  incidentCover: {
                    enum: ["No"]
                  }
                }   
              }]
            }
          }
        },
        incidentVehicleStatusInfo: {
          type: "object",
          title: "",
          required: ["incidentVehicleStatus"],    
          properties: {
            incidentVehicleStatus: {
              title: "Vehicle Driveable?",
              type: "string",
              enum: ["Yes", "No"]
            }
          },
          dependencies: {
            incidentVehicleStatus: {
              oneOf: [{
                required: ["incidentVehicleLocation", "incidentVehicleTowDetails"],  
                properties: {
                  incidentVehicleStatus: {
                    enum: ["No"]
                  },
                  incidentVehicleLocation: {
                    type: "string",
                    title: "Location Where Vehicle was Towed To?"
                  },
                  incidentVehicleTowDetails: {
                    type: "string",
                    title: "Provide Details of Tow Operator Used"
                  }
                }
              }, {
                properties: {
                  incidentVehicleStatus: {
                    enum: ["Yes"]
                  }
                }   
              }]
            }
          }
        },
        incidentAssistLineInfo: {
          type: "object",
          title: "",
          required: ["incidentAssistLine"],    
          properties: {
            incidentAssistLine: {
              title: "Was Western Assist Line Contacted?",
              type: "string",
              enum: ["Yes", "No"]
            }
          },
          dependencies: {
            incidentAssistLine: {
              oneOf: [{
                required: ["incidentWNReferenceNumber"],  
                properties: {
                  incidentAssistLine: {
                    enum: ["Yes"]
                  },
                  incidentWNReferenceNumber: {
                    title: "Western Assist Reference Number",
                    type: "string"
                  }
                }
              }, {
                properties: {
                  incidentAssistLine: {
                    enum: ["No"]
                  }
                }   
              }]
            }
          }
        }
      },
      dependencies: {
        incidentDriverDrugTest: {
          oneOf: [{
            properties: {
              incidentDriverDrugTest: {
                enum: ["Yes"]
              },
              incidentReport: {
                title: "If the Driver was Tested for Alcohol/Drug Use, Please Attach the Report",
                type: "array",
                description: "File Names Should Not Have Any Round Brackets. ()",
                items: {
                  type: "object",
                  properties: {
                    attachment: {
                      type: "array",
                      title: "Attachment",
                      items: [{
                        key: "attachName",
                        title: "Title",
                        type: "string",
                        maxLength: 200
                      }, {
                        key: "attachmentContent",
                        type: "array",
                        title: "Attachment",
                        items: {
                          type: "string",
                          format: "data-url"
                        }
                      }]
                    }
                  }
                }
              }
            }
          }, {
            properties: {
              incidentDriverDrugTest: {
                enum: ["No"]
              }
            }
          }]
        }
      }
    },
    vehicleDetails: {
      type: "object",
      title: "Vehicle Details",
      required: ["vehicleMake","vehicleModel","vehicleYear","vehicleRegistration"],
      properties: {
        vehicleMake: {
          type: "string",
          title: "Vehicle Make"
        },
        vehicleModel: {
          type: "string",
          title: "Vehicle Model"
        },
        vehicleYear: {
          type: "string",
          title: "Vehicle Year"
        },
        vehicleRegistration: {
          type: "string",
          title: "Registration Number"
        },
        vehicleVinNumber: {
          type: "string",
          title: "VIN Number"
        },
        vehicleEngineNumber: {
          type: "string",
          title: "Engine Number"
        }
      }
    },
    police: {
      type: "object",
      title: "Police",
      required: ["policeReported"],
      properties: {
        policeReported: {
          type: "string",
          title: "Was the Incident Reported to the Police?",
          enum: ["Yes", "No"]
        }
      },
      dependencies: {
        policeReported: {
          oneOf: [{
            properties: {
              policeReported: {
                enum: ["Yes"]
              },
              reportDetails: {
                type: "object",
                title: "Police Report Details",
                required: ["policePlaceReported", "policeDateReported", "policeCaseNumber"],
                properties: {
                  policePlaceReported: {
                    title: "Police Station Where Incident Reported",
                    type: "string"
                  },
                  policeDateReported: {
                    title: "Date Reported",
                    type: "string",
                    format: "date"
                  },
                  policeCaseNumber: {
                    title: "SAPS Case Number",
                    type: "string"
                  }
                }
              }
            }
          }, {
            properties: {
              policeReported: {
                enum: ["No"]
              },
              reportNote: {
                type: "null",
                title: "Please Report Incident to Police and Update Your Broker."
              }
            }
          }]
        }
      }
    },
    driverDetails: {
      type: "object",
      title: "Full Details of Driver",
      required: ["driverIsOwner"],
      properties: {
        driverIsOwner: {
          type: "string",
          title: "Is the Driver the Owner of the Vehicle?",
          enum: ["Yes", "No"]
        },
        driverDetails: {
                type: "object",
                title: "Details of Driver",
                required: ["driverFullName", "driverIdPassport", "driverContactNumber", "driverPermissionByInsured"],
                properties: {
                  driverFullName: {
                    type: "string",
                    title: "Driver Full Name"
                  },
                  driverIdPassport: {
                    type: "string",
                    title: "Driver ID/Passport Number"
                  },
                  driverContactNumber: {
                    type: "string",
                    title: "Driver Contact Number",
                    minLength: 10
                  },
                  driverEmail: {
                    type: "string",
                    format: "email",
                    title: "Driver Email"
                  },
                  driverPermissionByInsured: {
                    type: "string",
                    title: "Was the Driver Using the Vehicle with the Insured's Permission?",
                    enum: ["Yes", "No"]
                  }
                }
              }

    }},
    witnesses: {
      type: "object",
      title: "Witnesses",
      description: "Please Add Witnesses Details",
      properties: {
        witnessList: {
          title: "Witnesses",
          type: "array",
          items: {
            type: "object",
            properties: {
              witness: {
                type: "array",
                title: "Witness",
                items: [{
                  key: "name",
                  type: "string",
                  title: "Name"
                }, 
                {
                  key: "string",
                  type: "string",
                  title: "Contact Number",
                  minLength: 10
                }, 
                {
                  key: "address",
                  type: "string",
                  title: "Address"
                }]
              }
            }
          }
        }
      }
    },
    injuredPassengers: {
      type: "object",
      title: "Injured Passengers",
      required: ["injuredPassengersInjured"],
      properties: {
        injuredPassengersInjured: {
          type: "string",
          title: "Were there Any Passengers?",
          enum: ["Yes", "No"]
        }
      },
      dependencies: {
        injuredPassengersInjured: {
          oneOf: [{
            properties: {
              injuredPassengersInjured: {
                enum: ["Yes"]
              },  
              injured: {
                type: "object",
                title: "Injured Passengers",
                required: ["personalInjuries"],
                properties: {
                  personalInjuries: {
                    type: "string",
                    title: "Were Any Passengers Injured in the Incident",
                    enum: ["Yes", "No"]
                  }
                },
                dependencies: {
                  personalInjuries: {
                    oneOf: [{
                      properties: {
                        personalInjuries: {
                          enum: ["Yes"]
                        },
                        personalInjuriesList: {
                          title: "Passengers Injuries",
                          description: "Please Add Injured Parties Details",
                          required: ["name", "relationship"],
                          type: "array",
                          items: {
                            type: "object",
                            properties: {
                              person: {
                                type: "array",
                                title: "Injured Person",
                                items: [{
                                  key: "name",
                                  type: "string",
                                  title: "Name"
                                }, {
                                  key: "contactNumber",
                                  type: "string",
                                  title: "Contact Number",
                                  minLength: 10
                                }, {
                                  key: "email",
                                  type: "string",
                                  title: "Contact Email",
                                  format: "email"
                                }, {
                                  key: "idPassportNumber",
                                  type: "string",
                                  title: "ID/Passport Number"
                                }, {
                                  key: "address",
                                  type: "string",
                                  title: "Address"
                                }, {
                                  key: "age",
                                  type: "number",
                                  title: "Age"
                                }, {
                                  key: "relationship",
                                  title: "Relationships",
                                  description: "If Person Named Above is in your Service, your Tenant, or Related to You. Please Provide Details.",
                                  type: "string"
                                }]
                              }
                            }
                          }
                        }
                      }
                    }, {
                      properties: {
                        personalInjuries: {
                          enum: ["No"]
                        }
                      }
                    }]
                  }
                }
              },
            }
          }, {
            properties: {
              injuredPassengersInjured: {
                enum: ["No"]
              }
            }
          }]
        }
      }
    },
    thirdParty: {
      type: "object",
      title: "Third Party",
      required: ["thirdPartyName", "thirdPartyContactPerson", "thirdPartyContactNumber", "thirdPartyInsurer"],
      properties: {
        thirdPartyName: {
          type: "string",
          title: "Third Party Name"
        },
        thirdPartyContactPerson: {
          type: "string",
          title: "Third Party Contact Person"
        },
        thirdPartyContactNumber: {
          type: "string",
          title: "Third Party Contact Number",
          minLength: 10
        },
        thirdPartyEmail: {
          type: "string",
          format: "email",
          title: "Third Party Contact Email"
        },
        thirdPartyInsurer: {
          type: "string",
          title: "Is Third Party Insured",
          enum: ["Yes", "No"]
        }
      },
      dependencies: {
        thirdPartyInsurer: {
          oneOf: [{
            properties: {
              thirdPartyInsurer: {
                enum: ["Yes"]
              },
              thirdPartyInsurerInfo: {
                type: "object",
                title: "",
                properties: {
                  thirdPartyInsurerDetails: {
                    type: "string",
                    title: "Third Party Insurer Details"
                  },
                  thirdPartyPolicyNumber: {
                    type: "string",
                    title: "Third Party Policy Number"
                  }
                }
              }
            }
          }, {
            properties: {
              thirdPartyInsurer: {
                enum: ["No"]
              }
            }
          }]
        }
      }
    },
    thirdPartyvehicleDetails: {
      type: "object",
      title: "Third Party Vehicle Details",
      required: ["thirdPartyMake", "thirdPartyRegistration"],
      properties: {
        thirdPartyMake: {
          type: "string",
          title: "Vehicle Make"
        },
        thirdPartyModel: {
          type: "string",
          title: "Vehicle Model"
        },
        thirdPartyYear: {
          type: "number",
          title: "Vehicle Year"
        },
        thirdPartyRegistration: {
          type: "string",
          title: "Registration Number"
        },
        thirdPartyVinNumber: {
          type: "string",
          title: "VIN Number"
        }
      }
    },
    thirdPartyinjured: {
      type: "object",
      title: "Third Party Injured Persons",
      required: ["thirdPartyInjuries"],
      properties: {
        thirdPartyInjuries: {
          type: "string",
          title: "Were There Any Third Party Injuries",
          enum: ["Yes", "No"]
        }
      },
      dependencies: {
        thirdPartyInjuries: {
          oneOf: [{
            properties: {
              thirdPartyInjuries: {
                enum: ["Yes"]
              },
              thirdPartyInjuriesList: {
                title: "Third Party Injuries",
                description: "Please Add Injured Parties Details",
                required: ["name"],
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    person: {
                      type: "array",
                      title: "Injured Person",
                      items: [{
                        key: "name",
                        type: "string",
                        title: "Name"
                      }, 
                      {
                        key: "contactPerson",
                        type: "string",
                        title: "Contact Person"
                      },
                      {
                        key: "contactNumber",
                        type: "string",
                        title: "Contact Number",
                        minLength: 10
                      }, 
                      {
                        key: "email",
                        type: "string",
                        title: "Contact Email",
                        format: "email"
                      }, 
                      {
                        key: "injuriesDescription",
                        type: "string",
                        title: "Description of Injuries"
                      }]
                    }
                  }
                }
              }
            }
          }, {
            properties: {
              thirdPartyInjuries: {
                enum: ["No"]
              }
            }
          }]
        }
      }
    },
    attachments: {
      type: "object",
      title: "Attachments",
      description: `Please Attach Any of the Following Applicable Documents:
      - Sketch of Events Resulting on Loss or Damage
      - Police Report
      - Photo of Driver’s License
      - Photo of License Disk
      - Photos of All Sides of your Vehicle
      - Photos of the Accident Scene 
      - Photos of 3rd Party Vehicle`,
      properties: {
        attachmentsList: {
          title: "Attachments",
          type: "array",
          required: ["attachmentContent"],
          items: {
            type: "object",
            properties: {
              attachment: {
                type: "array",
                title: "Attachment",
                items: [{
                  key: "attachName",
                  title: "Title",
                  type: "string",
                  maxLength: 200
                }, {
                  key: "attachmentContent",
                  type: "array",
                  title: "Attachment",
                  items: {
                    type: "string",
                    format: "data-url"
                  }
                }]
              }
            }
          }
        }
      }
    },
    declaration: {
      type: "object",
      title: "Declaration",
      required: ["insuredaccepttc"],
      description: "I/we declare that to the best of my/our knowledge the above statements are true. I acknowledge that the information set out above is provided freely so that Western may process my claim and give effect to the terms and conditions contained in the policy wording. I herewith give my consent that Western may use this information, my personal information on record and additional information obtained from other sources in order to determine whether to accept or reject my claim and take all necessary steps ancillary thereto to give effect hereto. I understand that I may be liable for output VAT in terms of section 8(8) of the VAT Act 89 of 1991.",
      properties: {
        insuredaccepttc: {
          type: "boolean",
          title: "Accept Terms and Conditions",
          description: "Tick Box to Accept Terms and Conditions"
        },
        insuredcapcity: {
          type: "string",
          title: "Capacity"
        },
        insureddate: {
          type: "string",
          title: "Date",
          format: "date"
        }
      }
    }
  }
};

export var uiSchema = {
  incidentLat: {
    "ui:widget": "hidden"
  },
  incidentLong: {
    "ui:widget": "hidden"
  },
  incidentDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  incidentCoverInfo: {
    incidentPolicyDetails: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 5
      }
    }
  },
  reportDetails: {
    policePlaceReported: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 5
      }
    }
  },
  witnessList: {
    "ui:options": {
      orderable: false
    }
  },
  injuredPassengersInjured: {
    personalInjuriesList: {
      "ui:options": {
        orderable: false
      }
    }
  },
  thirdPartyInsurerInfo: {
    thirdPartyInsurerDetails: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 5
      }
    }
  },
  thirdPartyInjuries:{
    thirdPartyInjuriesList: {
      "ui:options": {
        orderable: false
      }
    }
  }
};